export var ForgeProjectFeatureStatus;
(function (ForgeProjectFeatureStatus) {
    ForgeProjectFeatureStatus["DRAFT"] = "Draft";
    ForgeProjectFeatureStatus["READY_FOR_DEVELOPMENT"] = "ReadyForDevelopment";
})(ForgeProjectFeatureStatus || (ForgeProjectFeatureStatus = {}));
export class ForgeProjectFeature {
    constructor(model) {
        var _a, _b, _c, _d;
        this.id = model.id;
        this.threadId = model.threadId;
        this.lastReplyTimestamp = model.lastReplyTimestamp;
        this.name = model.name;
        this.description = model.description;
        this.isArchived = (_a = model.isArchived) !== null && _a !== void 0 ? _a : false;
        this.projectId = model.projectId;
        this.createdAt = new Date(model.createdAt);
        this.createdByUserId = model.createdByUserId;
        this.updatedAt = model.updatedAt ? new Date(model.updatedAt) : undefined;
        this.sectionId = (_b = model.sectionId) !== null && _b !== void 0 ? _b : null;
        this.sortOrder = model.sortOrder;
        this.status = model.status;
        this.numberOfIterations = model.numberOfIterations;
        this.numberOfBookmarkedIterations = model.numberOfBookmarkedIterations;
        this.lastReplyTimestamp = model.lastReplyTimestamp;
        this.threadId = model.threadId;
        this.thumbnailUrl = (_d = (_c = model.thumbnail) === null || _c === void 0 ? void 0 : _c.url) !== null && _d !== void 0 ? _d : undefined;
    }
    toRemote() {
        var _a, _b;
        return Object.assign(Object.assign({}, this), { sectionId: (_a = this.sectionId) !== null && _a !== void 0 ? _a : undefined, createdAt: this.createdAt.toISOString(), updatedAt: (_b = this.updatedAt) === null || _b === void 0 ? void 0 : _b.toISOString() });
    }
}
